import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import WhatsAppChat from './components/Whatsapp';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import BookOnline from './components/BookOnline';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Tracking from './components/Tracking';
import RateCalculator from './components/RateCalculator';
import FAQ from './components/Faq';
import AirFreight from "./components/AirFreight";
import SeaFreight from "./components/SeaFreight";
import Warehousing from "./components/Warehousing";
import './App.css';
import ScrollToTop from "./components/ScrollToTop";

function AppContent() {
  const location = useLocation();

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
      mirror: true,
    });
    AOS.refresh();
  }, [location.pathname]);

  return (
    <>
      <Navbar />

      <Routes>
        <Route
          path="/"
          element={
            <>
              <Hero />
              <Services />
              <About />
              <BookOnline />
              <Contact />
              <Footer />
            </>
          }
        />

        <Route path="/tracking" element={<Tracking />} />
        <Route path="/rate-calculator" element={<RateCalculator />} />
        <Route path="/about" element={<About />} />
        <Route path="/faqs" element={<FAQ />} />
        <Route path="/air-freight" element={<AirFreight />} />
        <Route path="/sea-freight" element={<SeaFreight />} />
        <Route path="/warehousing" element={<Warehousing />} />
      </Routes>

      <WhatsAppChat /> 
    </>
  );
}

function App() {
  return (
    
    <Router>
       <ScrollToTop />
      <AppContent />
    </Router>
  );
}

export default App;
